import React from 'react';
import { useGallery } from '../context/GalleryContext';
import Photo from '../components/Photo';
import { motion } from 'framer-motion';
import { FaHeart } from 'react-icons/fa';
import './Favorites.css';

const Favorites = () => {
  const { favorites } = useGallery();

  return (
    <div className="favorites-container">
      <div className="favorites-header">
        <h1>Your Favorites</h1>
        <p>
          {favorites.length} {favorites.length === 1 ? 'masterpiece' : 'masterpieces'} saved to your collection.
        </p>
      </div>

      {favorites.length > 0 ? (
        <div className="gallery-grid">
          {favorites.map((photo) => (
            <Photo key={photo.id} {...photo} />
          ))}
        </div>
      ) : (
        <div className="empty-favorites">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="empty-icon"
          >
            <FaHeart />
          </motion.div>
          <h2>No favorites yet</h2>
          <p>Start exploring the gallery and save the artworks that inspire you.</p>
        </div>
      )}
    </div>
  );
};

export default Favorites; 